import React from "react"
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"

import {
  Wrapper,
  WrapperBlack,
  Inner,
  Row,
  Col6,
  Col6Left,
  Col12,
  Label,
  LabelLight,
  LabelRight,
  HandleImageWidth,
  HandleImageWidthSmall,
  Heading3,
  Heading1Red,
} from "../../styles/styles"

const Section2 = ({ data }) => (
  <>
    <Wrapper>
      <Row>
        <Col6Left>
          <Label>LOGO LOCKUP</Label>
          <Inner>
            <HandleImageWidth>
              <Img
                fluid={data.stackedLogoLeft.childImageSharp.fluid}
              />
            </HandleImageWidth>
          </Inner>
        </Col6Left>
        <Col6>
          <LabelRight>PRIMARY LOGO</LabelRight>
          <Inner>
            <HandleImageWidth>
              <Img
                fluid={data.stackedLogoRight.childImageSharp.fluid}
              />
            </HandleImageWidth>
          </Inner>
        </Col6>
      </Row>
    </Wrapper>
    <Wrapper>
      <Row>
        <Col6Left>
          <Label>LOGO LOCKUP</Label>
          <Inner>
            <HandleImageWidth>
              <Img
                fluid={data.stackedLogoOnly.childImageSharp.fluid}
              />
            </HandleImageWidth>
          </Inner>
        </Col6Left>
        <Col6>
          <LabelRight>ICON ONLY</LabelRight>
          <Inner>
            <HandleImageWidth>
              <Img
                fluid={data.stackedLogoOnly.childImageSharp.fluid}
              />
            </HandleImageWidth>
          </Inner>
        </Col6>
      </Row>
    </Wrapper>
    <WrapperBlack>
      <Row>
        <Col12>
          <Row>
            <Col6><LabelLight>LOGO LOCKUP</LabelLight></Col6>
            <Col6><LabelRight>GREYSCALE</LabelRight></Col6>
          </Row>
          <Inner>
            <HandleImageWidth>
              <Img
                fluid={data.greyScale.childImageSharp.fluid}
              />
            </HandleImageWidth>
          </Inner>
        </Col12>
      </Row>
    </WrapperBlack>
    <Wrapper>
      <Row>
        <Col12>
          <Row>
            <Col6><LabelLight>LOGO LOCKUP</LabelLight></Col6>
            <Col6><LabelRight>HORIZONTAL</LabelRight></Col6>
          </Row>
          <Inner>
            <HandleImageWidth>
              <Img
                fluid={data.horizontalLight.childImageSharp.fluid}
              />
            </HandleImageWidth>
          </Inner>
        </Col12>
      </Row>
    </Wrapper>
    <Wrapper>
      <Row>
        <Col6Left>
          <Label>LOGO LOCKUP</Label>
          <Inner>
            <HandleImageWidthSmall>
              <Img
                fluid={data.stackedLogoInitials.childImageSharp.fluid}
              />
            </HandleImageWidthSmall>
          </Inner>
        </Col6Left>
        <Col6>
          <LabelRight>STACKED INITIALS</LabelRight>
          <Inner>
            <HandleImageWidthSmall>
              <Img
                fluid={data.stackedInitials.childImageSharp.fluid}
              />
            </HandleImageWidthSmall>
          </Inner>
        </Col6>
      </Row>
    </Wrapper>
    <Wrapper>
      <Row>
        <Col12>
          <Inner>
            <Heading3>Round 1.</Heading3>
            <Heading1Red>END</Heading1Red>
          </Inner>
        </Col12>
      </Row>
    </Wrapper>
  </>
)

export default props => (
  <StaticQuery
    query={graphql`
      query {
        stackedLogoLeft: file(relativePath: { eq: "pacific_kaiju_logolockups_logo_dark_RGB@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        stackedLogoRight: file(relativePath: { eq: "pacific_kaiju_logolockups_logo_light_RGB@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        stackedLogoOnly: file(relativePath: { eq: "Group2@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        greyScale: file(relativePath: { eq: "pacific_kaiju_logolockups_logo_reverse_RGB@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        horizontalLight: file(relativePath: { eq: "pacific_kaiju_logolockups_logo_horizontal_light_RGB@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        stackedLogoInitials: file(relativePath: { eq: "pacific_kaiju_logolockups_logo_initials_RGB@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        stackedInitials: file(relativePath: { eq: "pacific_kaiju_logolockups_logo_stackedbox_RGB@3x.png" }) {
          childImageSharp {
            fluid(maxWidth: 1348, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => <Section2 data={data} {...props} />}
  />
)
